import React, {useEffect, useState} from "react";
import { ItemsBloqueHome } from "./ItemsBloqueHome";
import { ArrepentimientoModal } from "./ArrepentimientoModal";

export const BloqueHome = () => {
    let handleOpen = () => {
        let backdrop = document.querySelector(".form-modalBackdrop");
        backdrop.style.opacity = "1";
        backdrop.style.zIndex = "99999";

        let form = document.querySelector(".form-modalScreen");
        form.style.opacity = "1";
        form.style.zIndex = "999999";

        document.getElementById("cuit-focus").focus();
    };

    let handleClose = () => {
        let backdrop = document.querySelector(".form-modalBackdrop");
        backdrop.style.opacity = "0";
        backdrop.style.zIndex = "-1";

        let form = document.querySelector(".form-modalScreen");
        form.style.opacity = "0";
        form.style.zIndex = "-1";
    };

    const [listaCuotasPendientes, setListaCuotasPendientes] = useState('')

    useEffect(() => {
        const asyncFunction = async () => {
            const endpoint = await (await fetch('/api/show_endpoints/listaCuotasPendientes')).json();
            console.log(endpoint.estado)
            if (endpoint.estado == 0) {
                setListaCuotasPendientes('login_mi_plan')
            }else{
                setListaCuotasPendientes(`${endpoint.url_base}${endpoint.url_variable}`)
            }
        }
            asyncFunction();
    }, []);

    return (
        <div className="d-flex justify-content-center align-items-center py-half">
            <div className="bloqueHomeContainer">
                <ItemsBloqueHome
                    logo="/images/icons/paga-tu-cuota.svg"
                    texto="PAGAR CUOTA"
                    href={listaCuotasPendientes}
                    to="/login_mi_plan"
                />
                <ItemsBloqueHome
                    logo="/images/icons/preguntas-frecuentes.svg"
                    texto="PREGUNTAS FRECUENTES"
                    to="/preguntas_frecuentes"
                />
                <ItemsBloqueHome
                    logo="/images/icons/gastos-de-entrega.svg"
                    texto="GASTOS DE ENTREGA"
                    to="/gastos_de_entrega"
                />
                <ItemsBloqueHome
                    logo="/images/icons/atencion-al-cliente.svg"
                    texto="ATENCIÓN AL CLIENTE"
                    href="https://crmfcalatam.my.site.com/selfservicepda/s/jeep"
                />
                <ItemsBloqueHome
                    logo="/images/icons/canales-de-atencion.svg"
                    texto="CANALES DE ATENCIÓN"
                    to="/canales_de_atencion"
                />
                <ItemsBloqueHome
                    logo="/images/icons/arrepentimiento.svg"
                    logoStyle={{ height: "50px" }}
                    texto="ARREPENTIMIENTO"
                    action={handleOpen}
                />

                <ArrepentimientoModal handleClose={handleClose} />
            </div>
        </div>
    );
};
